import { useQuery } from '@tanstack/react-query';

import { fetchListSixInfoApi } from '../api';

export default function useListSixInfoQuery(id: number, options?: any) {
  return useQuery(['list', 'six', 'info', id], fetchListSixInfoApi, options);
}
